export const suppliersDetailsRoutes = [
  {
    path: ':reference_number',
    name: 'suppliers-details',
    component: () => import(/* webpackChunkName: "Suppliers-details" */ './SuppliersDetails.vue')
  }
];
